import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configArticlePages_template } from "../components/templates/configArticlePages_template";
import {header} from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {isNotEmpty} from "@amcharts/amcharts4/.internal/core/utils/Utils";

declare var ko: any;
declare var page: any;

export class config_article_pages extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected articlePages: configArticlePages_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){
        return "config_article_pages";
    }

    buildContent() : Array<Element>{

        this.articlePages = new configArticlePages_template( "articlePages", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Article Pages");

        return [ this.articlePages.build()];
    }

    public fillPage() : void{
        this.getGeneralConfigData();
    }

    private  getGeneralConfigData(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let subViewModel = {list: {keyword: this.getModuleName()}};
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let article_pages_settings = responseParsed.datas.article_pages_settings
                obj.articlePages.setContentTypeOptions(responseParsed.datas.contentTypes || []);
                if (article_pages_settings){
                    obj.articlePages.set_article_social_share_links(obj.initArticleSocialShareLinks(article_pages_settings['social_share_links']));
                    obj.articlePages.set_isBreadcrumbEnable(article_pages_settings['isBreadcrumbEnable']);
                    obj.articlePages.set_isTrueAnthemEnable(article_pages_settings['isTrueAnthemEnable']);
                    obj.articlePages.set_isReadNextEnable(article_pages_settings['isReadNextEnable']);
                    obj.articlePages.set_additionalCreditEnabled(article_pages_settings['additionalCreditEnabled']);
                    obj.articlePages.set_isTimeUpdateEnable(article_pages_settings['isTimeUpdateEnable']);
                    obj.articlePages.set_defaultListOrder(article_pages_settings['defaultListOrder']);
                    obj.articlePages.set_keyTakeawayTitle(article_pages_settings['keyTakeawayTitle']);
                    obj.articlePages.set_isAudioReaderDefaultEnabled(article_pages_settings['isAudioReaderDefaultEnabled']);
                    obj.articlePages.set_audioReaderDefaultContentTypes(article_pages_settings['audioReaderDefaultContentTypes']);
                    obj.articlePages.set_isPollDynamicPlacementOnByDefault(!!article_pages_settings['isPollDynamicPlacementOnByDefault']);
                    obj.articlePages.set_isQuizDynamicPlacementOnByDefault(!!article_pages_settings['isQuizDynamicPlacementOnByDefault']);
                } else {
                    obj.articlePages.set_article_social_share_links(obj.initArticleSocialShareLinks(null));
                    obj.articlePages.set_isBreadcrumbEnable(true);
                    obj.articlePages.set_defaultListOrder("descending");
                    obj.articlePages.set_isAudioReaderDefaultEnabled(false);
                    obj.articlePages.set_audioReaderDefaultContentTypes([]);
                }
            })
        }
    }

    public filterMultipleSelectorOnChange(idElement = null) {
        if (idElement === 'articlePages_audioReaderContentTypeFilter') {
            this.articlePages.updateSelectedAudioReaderDefaultContentTypes();
        }
    }

    private initArticleSocialShareLinks(articleSocialShareLinks): Array<object> {
        let facebookIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("facebook") : -1;
        let twitterIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("twitter") : -1;
        let whatsappIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("whatsapp") : -1;
        let linkedinIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("linkedin") : -1;
        let threadsIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("threads") : -1;
        let blueskyIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("bluesky") : -1;
        let redditIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("reddit") : -1;
        let flipboardIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("flipboard") : -1;
        let copyLinkIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("copy link") : -1;
        let emailIndex = (articleSocialShareLinks != null) ? articleSocialShareLinks.map(function(e) { return e.type; }).indexOf("email") : -1;

        return [
            {
                'type': 'facebook',
                'iconClass': 'icon i-facebook',
                'enabled': {
                    'top': (articleSocialShareLinks != null && facebookIndex != -1) ? articleSocialShareLinks[facebookIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && facebookIndex != -1) ? articleSocialShareLinks[facebookIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'twitter',
                'iconClass': 'icon i-twitter',
                'enabled': {
                    'top': (articleSocialShareLinks != null && twitterIndex != -1) ? articleSocialShareLinks[twitterIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && twitterIndex != -1) ? articleSocialShareLinks[twitterIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'whatsapp',
                'iconClass': 'icon i-whatsapp',
                'enabled': {
                    'top': (articleSocialShareLinks != null && whatsappIndex != -1) ? articleSocialShareLinks[whatsappIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && whatsappIndex != -1) ? articleSocialShareLinks[whatsappIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'threads',
                'iconClass': 'icon i-threads',
                'enabled': {
                    'top': (articleSocialShareLinks != null && threadsIndex != -1) ? articleSocialShareLinks[threadsIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && threadsIndex != -1) ? articleSocialShareLinks[threadsIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'bluesky',
                'iconClass': 'icon i-bluesky',
                'enabled': {
                    'top': (articleSocialShareLinks != null && blueskyIndex != -1) ? articleSocialShareLinks[blueskyIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && blueskyIndex != -1) ? articleSocialShareLinks[blueskyIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'linkedin',
                'iconClass': 'icon i-linkedin',
                'enabled': {
                    'top': (articleSocialShareLinks != null && linkedinIndex != -1) ? articleSocialShareLinks[linkedinIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && linkedinIndex != -1) ? articleSocialShareLinks[linkedinIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'reddit',
                'iconClass': 'icon i-reddit',
                'enabled': {
                    'top': (articleSocialShareLinks != null && redditIndex != -1) ? articleSocialShareLinks[redditIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && redditIndex != -1) ? articleSocialShareLinks[redditIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'flipboard',
                'iconClass': 'icon i-flipboard',
                'enabled': {
                    'top': (articleSocialShareLinks != null && flipboardIndex != -1) ? articleSocialShareLinks[flipboardIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && flipboardIndex != -1) ? articleSocialShareLinks[flipboardIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'copy link',
                'iconClass': 'icon i-link',
                'enabled': {
                    'top': (articleSocialShareLinks != null && copyLinkIndex != -1) ? articleSocialShareLinks[copyLinkIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && copyLinkIndex != -1) ? articleSocialShareLinks[copyLinkIndex]['enabled']['bottom'] : false
                }
            },
            {
                'type': 'email',
                'iconClass': 'icon i-newsletter',
                'enabled': {
                    'top': (articleSocialShareLinks != null && emailIndex != -1) ? articleSocialShareLinks[emailIndex]['enabled']['top'] : false,
                    'bottom': (articleSocialShareLinks != null && emailIndex != -1) ? articleSocialShareLinks[emailIndex]['enabled']['bottom'] : false
                }
            }];
    }

    protected saveData(data, param) {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/articlePages/save/";
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(data)]);
        formReq_params.push(["param", param]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/article-pages/");

                });
                obj.loadingOut(obj.articlePages.builtTemplate);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");
                // obj.getVnAppZone().showNotificationToModule();

            }
        });
        XHRHdl.execute();
    }

    protected cancelArticleSocialMedia() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Article Pages changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/articles/");

    }
}



// WEBPACK FOOTER //
// ./js/modules/config_article_pages.ts